import { render } from "./AppTopbar.vue?vue&type=template&id=c0e5b782"
import script from "./AppTopbar.vue?vue&type=script&lang=js"
export * from "./AppTopbar.vue?vue&type=script&lang=js"

import "./AppTopbar.vue?vue&type=style&index=0&id=c0e5b782&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\polaris-front-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__